import React from 'react';

const Free = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}>
      <path
        d="M10.1357 2.32275C10.3887 2.07005 10.7989 2.06987 11.0518 2.32275C11.3045 2.57565 11.3044 2.9858 11.0518 3.23877L10.0244 4.26611H13.7061C14.0532 4.26641 14.3348 4.54515 14.335 4.88818V6.7124C14.3347 7.05528 14.0531 7.3332 13.7061 7.3335H13.6348V12.4995C13.6346 13.2357 13.0379 13.8324 12.3018 13.8325H3.70215C2.96585 13.8325 2.3683 13.2358 2.36816 12.4995V7.3335H2.29785C1.95059 7.3335 1.66828 7.05546 1.66797 6.7124V4.88818C1.66808 4.54496 1.95047 4.26611 2.29785 4.26611H5.98047L4.95312 3.23877C4.70018 2.98579 4.70016 2.57572 4.95312 2.32275C5.2061 2.06992 5.6162 2.06986 5.86914 2.32275L7.81152 4.26611H8.19238L10.1357 2.32275ZM7.40137 11.5249H8.60449V8.73291H7.40137V11.5249Z"
        fill="white"
      />
      <path
        d="M10.1357 2.32275C10.3887 2.07005 10.7989 2.06987 11.0518 2.32275C11.3045 2.57565 11.3044 2.9858 11.0518 3.23877L10.0244 4.26611H13.7061C14.0532 4.26641 14.3348 4.54515 14.335 4.88818V6.7124C14.3347 7.05528 14.0531 7.3332 13.7061 7.3335H13.6348V12.4995C13.6346 13.2357 13.0379 13.8324 12.3018 13.8325H3.70215C2.96585 13.8325 2.3683 13.2358 2.36816 12.4995V7.3335H2.29785C1.95059 7.3335 1.66828 7.05546 1.66797 6.7124V4.88818C1.66808 4.54496 1.95047 4.26611 2.29785 4.26611H5.98047L4.95312 3.23877C4.70018 2.98579 4.70016 2.57572 4.95312 2.32275C5.2061 2.06992 5.6162 2.06986 5.86914 2.32275L7.81152 4.26611H8.19238L10.1357 2.32275ZM7.40137 11.5249H8.60449V8.73291H7.40137V11.5249Z"
        fill="url(#paint0_linear_5556_80484)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5556_80484"
          x1="-3.08215"
          y1="7.98301"
          x2="14.3394"
          y2="8.10225"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#FF5353" />
          <stop offset="0.614583" stop-color="#6D38FB" />
          <stop offset="1" stop-color="#009DFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Free;
